import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.get('direct_estimate', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['directEstimate'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  // フラワーコーディネートシート印刷APIへリクエスト
  print: (bvModal, params, callback) => {
    return AppModel.get('/print_estimate', bvModal, params, (res) => {
      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('directEstimate', key)
  },
  removeStore: () => {
    delete store.getters.model.directEstimate
  }
}
